import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import {
  AlertStyledContainer,
  AlertSubTitle,
  AlertTextContainer,
  AlertTitle,
  AlertTitleContainer,
  ExitPreviewButton,
  TitleContainer,
} from './PreviewModal.styled';
import SectionContent from './SectionContent';
import SectionTitle from './SectionTitle';
import LastEdited from './LastEdited';
import { VisibilityOnIcon } from './ActionBar.styled';

class PreviewModal extends React.PureComponent {
  render() {
    const {
      open,
      onClose,
      previewData,
      section,
      onGetSection,
      setUploadState,
      onDiscussionSave,
      correlationId,
      permissions,
      isRbacEnabled,
    } = this.props;

    if (!open || !previewData) {
      return null;
    }

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <AlertStyledContainer>
            <AlertTitleContainer>
              <VisibilityOnIcon style={{ color: '#0288D1' }} />
              <AlertTextContainer>
                <AlertTitle>Page Preview</AlertTitle>
                <AlertSubTitle>
                  This is how your page will look to the users
                </AlertSubTitle>
              </AlertTextContainer>
            </AlertTitleContainer>
            <ExitPreviewButton type="button" onClick={onClose}>
              Exit Preview
            </ExitPreviewButton>
          </AlertStyledContainer>
        </DialogTitle>
        <DialogContent>
          <TitleContainer>
            <SectionTitle editable={false} value={previewData.title} />
          </TitleContainer>
          <LastEdited
            editedAt={section.updatedAt}
            createdAt={section.createdAt}
          />
          <SectionContent
            editable={false}
            content={previewData.content}
            onGetSection={onGetSection}
            isLoadingContent={false}
            reverting={false}
            sectionId={section.id}
            setUploadState={setUploadState}
            discussionTopic={previewData.discussionTopic}
            showDiscussion={previewData.showDiscussion}
            onDiscussionSave={onDiscussionSave}
            correlationId={correlationId}
            permissions={permissions}
            isRbacEnabled={isRbacEnabled}
          />
        </DialogContent>
      </Dialog>
    );
  }
}

PreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  previewData: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.object,
    discussionTopic: PropTypes.string,
    showDiscussion: PropTypes.bool,
  }),
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    updatedAt: PropTypes.string,
    createdAt: PropTypes.string,
  }).isRequired,
  onGetSection: PropTypes.func.isRequired,
  setUploadState: PropTypes.func.isRequired,
  onDiscussionSave: PropTypes.func.isRequired,
  correlationId: PropTypes.string.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string),
  isRbacEnabled: PropTypes.bool,
};

PreviewModal.defaultProps = {
  previewData: null,
  permissions: [],
  isRbacEnabled: false,
};

export default PreviewModal;
